<script>
export default {
    computed: {
        refunds() {
            return this.$store.getters.BILLING_REFUNDS;
        },
        isLoading() {
            return this.$store.getters.IS_REFUNDS_LOADING;
        },
    },
    methods: {
        reviewRefund(refund) {
            this.$store.commit('REFUND_REVIEW_SET', refund);
            this.$store.commit('IS_SHOW_REFUND_REVIEW', true);
        },
        formatDate(dateString) {
            if (!dateString) return 'N/A';
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return 'N/A';
            return date.toLocaleString('en-US', {
                timeZone: 'Europe/Minsk',
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            });
        },
        getStatusClass(status) {
            const statusMap = {
                pending: 'status_pending',
                approved: 'status_approved',
                rejected: 'status_rejected',
                completed: 'status_completed',
                failed: 'status_failed',
            };
            return statusMap[status] || '';
        },
    },
};
</script>

<template>
    <div class="right_container_block">
        <div class="right_header">
            <label>Refund Requests:</label>
        </div>

        <div v-if="isLoading" class="loading_container">
            <p>Loading refunds...</p>
        </div>

        <div v-else-if="refunds.length === 0" class="no_refunds">
            <p>No pending refund requests</p>
        </div>

        <table v-else>
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Date</th>
                    <th>User</th>
                    <th>Amount</th>
                    <th>Reason</th>
                    <th>Status</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="refund in refunds" :key="refund.id">
                    <td>{{ refund.id }}</td>
                    <td>{{ formatDate(refund.created_at) }}</td>
                    <td>
                        <router-link
                            :to="{
                                name: 'userEditWithId',
                                params: { userId: refund.user_id },
                            }"
                            target="_blank"
                            class="user_link"
                        >
                            #{{ refund.user_id }}
                        </router-link>
                    </td>
                    <td>{{ refund.currency }} {{ refund.amount }}</td>
                    <td class="reason_cell">{{ refund.reason }}</td>
                    <td>
                        <span
                            class="status_badge"
                            :class="getStatusClass(refund.status)"
                        >
                            {{ refund.status }}
                        </span>
                    </td>
                    <td>
                        <button
                            v-if="refund.status === 'pending'"
                            class="button_blue_100"
                            @click="reviewRefund(refund)"
                        >
                            Review
                        </button>
                        <span v-else>-</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<style scoped>
.right_container_block {
    padding: 20px;
}

.right_header {
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: 600;
    color: var(--text-color);
}

.loading_container,
.no_refunds {
    padding: 40px 20px;
    text-align: center;
    color: var(--text-color-secondary);
}

table {
    width: 100%;
    border-collapse: collapse;
}

th {
    padding: 12px 15px;
    text-align: left;
    font-weight: 600;
    color: var(--text-color);
    border-bottom: 2px solid var(--border-color);
    background: var(--background);
    position: sticky;
    top: 0;
}

td {
    padding: 12px 15px;
    border-bottom: 1px solid var(--border-color);
    color: var(--text-color-primary);
}

tr:hover td {
    background: var(--background-hover);
}

.user_link {
    color: var(--main-color);
    text-decoration: none;
    font-weight: 600;
}

.user_link:hover {
    text-decoration: underline;
}

.reason_cell {
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.status_badge {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
}

.status_pending {
    background: rgba(255, 152, 0, 0.2);
    color: #ff9800;
}

.status_approved {
    background: rgba(33, 150, 243, 0.2);
    color: #2196f3;
}

.status_rejected {
    background: rgba(244, 67, 54, 0.2);
    color: #f44336;
}

.status_completed {
    background: rgba(76, 175, 80, 0.2);
    color: #4caf50;
}

.status_failed {
    background: rgba(200, 50, 50, 0.2);
    color: #c03232;
}
</style>
